//Based on Pixel 7 Pro - 480x1040
const screenBreakpoint = 480
export const MOBILE_VIEWPORT = { width: screenBreakpoint - 1, height: 812 }
export const useIsDesktop = () => window.innerWidth > screenBreakpoint
